import { CornersIn, CornersOut } from "phosphor-react-sc"
import { isMobile } from "../../../../../helpers/DeviceHelpers";
import { stopPropagation } from "../../../../../helpers/ObjectHelpers";
import { getElementById } from "../../../../../helpers/ElementHelpers";
import { useMapId } from "../../../hooks/useMapStore";

interface MapControlFullscreenProps {
    setIsFulllscreen: (e: boolean) => void,
    isFullscreen: boolean
}
export const MapControlFullscreen = ({
    setIsFulllscreen,
    isFullscreen
}: MapControlFullscreenProps) => {

    const show = !isMobile();
    const { mapId } = useMapId();

    return (
        show &&
        <div onClick={onClick} className="google-map-control-button google-map-control-fullscreen google-map-control">
            {
                isFullscreen ?
                    <CornersIn size={20} />
                    :
                    <CornersOut size={20} />
            }
        </div>
    )

    function onClick(e: any) {
        stopPropagation(e);

        const mapElem = getElementById(mapId);
        if (!mapElem) return;

        const elem: HTMLElement | null = mapElem.querySelector(".gm-fullscreen-control");
        if (!elem) return;

        elem.click();

        setIsFulllscreen(!isFullscreen);
    }
}
